import React, { Component } from 'react';
import classes from './SessionAttendanceTable.module.css';

class SessionAttendanceTable extends Component {
    data = this.props.data;

    render() {
        return (
            <div className={classes.TableContainer}>
                <table className={classes.TableStyle}>
                    <thead className={classes.TableHead}>
                        <tr className={classes.TableRow}>
                            <td className={[classes.Border, classes.Sessions].join(' ')}>
                                <div>Total Sessions</div>
                                <div className={[classes.WeekNumberStyle, classes.TextStyle].join(' ')}>{this.props.reportData.totalSessions}</div>
                            </td>
                            <td className={classes.WeekDay}>Mo</td>
                            <td className={classes.WeekDay}>Tu</td>
                            <td className={classes.WeekDay}>We</td>
                            <td className={classes.WeekDay}>Th</td>
                            <td className={classes.WeekDay}>Fr</td>
                            <td className={classes.WeekDay}>Sa</td>
                            <td className={classes.WeekDay}>Su</td>
                            <td className={[classes.Border, classes.NarrowColumn].join(' ')}>COUNT</td>
                            <td className={[classes.Border, classes.NarrowColumn, classes.DaysMissed].join(' ')}>
                                <div>Days Missed</div>
                                <div className={this.props.reportData.daysMissed === 0 ? '' : classes.TextStyleRed}>{this.props.reportData.daysMissed}</div></td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.data.map((item, index) => (
                            <tr className={classes.TableRow} key={index}>
                                <td className={classes.Border}>
                                    <div className={classes.WeekNumberStyle}>{item.weekName}</div>
                                    <div className={classes.DateStyle}>{item.weekDates}</div>
                                </td>
                                <td className={[classes.Days, classes.Count].join(' ')}>{item.Mo != null ? item.Mo : "-"}</td>
                                <td className={classes.Count}>{item.Tu != null ? item.Tu : "-"}</td>
                                <td className={classes.Count}>{item.We != null ? item.We : "-"}</td>
                                <td className={classes.Count}>{item.Th != null ? item.Th : "-"}</td>
                                <td className={classes.Count}>{item.Fr != null ? item.Fr : "-"}</td>
                                <td className={classes.Count}>{item.Sa != null ? item.Sa : "-"}</td>
                                <td className={classes.Count}>{item.Su != null ? item.Su : "-"}</td>
                                <td className={[classes.Border, classes.Count].join(' ')}>{item.count != null ? item.count : "-"}</td>
                                <td className={[classes.Border, item.missed === 0 ? '' : classes.TextStyleRed, classes.DaysMissed].join(' ')}>{item.missed}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default SessionAttendanceTable;